module.exports = __webpack_public_path__ + "img/speed.783bc184.gif";